import { WidgetType } from 'domain/entity/widget';
import { WidgetTextDescription } from 'domain/entity/widgets/TextData';

export type WidgetRichText = {
    type: WidgetType;
    description?: WidgetTextDescription;
    text: string;
};

export class WidgetRichTextContent {
    constructor(readonly text: string) {}
}

class RichTextData implements WidgetRichText {
    type = WidgetType.RICH_TEXT;

    constructor(readonly text: string, public description?: WidgetTextDescription) {}
}

export default RichTextData;
